/**
 * トップページMV内の矢印ボタン用ページ内ジャンプ
 *
 * .figure_button の data-target に指定された要素へ、
 * クリック時にスムーススクロールで移動する。
 */
document.addEventListener("DOMContentLoaded", function () {
  // data-target を持つ矢印ボタンを取得する
  var buttons = document.querySelectorAll(".figure_button[data-target]");

  // 対象ボタンがないページでは何もしない
  if (!buttons.length) return;

  buttons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      // data-target のセレクタからスクロール先の要素を取得する
      var targetSelector = button.dataset.target;
      var target = targetSelector ? document.querySelector(targetSelector) : null;

      // スクロール先が存在しない場合は通常の挙動に任せる
      if (!target) return;

      e.preventDefault();

      // ヘッダーが透過固定のため、オフセットせず要素の位置まで移動する
      var position = target.getBoundingClientRect().top + window.scrollY;

      // スムーススクロールで目的のセクションへ移動する
      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // スクロール後の現在地が分かるよう、URLにハッシュを反映する
      history.pushState(null, "", targetSelector);
    });
  });
});
